import { watch } from 'vue'

/**
 * Старт аналитики на клиенте (ТЗ §5.3, §11.2): загрузить конфиг витрины,
 * восстановить решение по cookies и инициализировать счётчик — сразу, если
 * согласие не требуется, либо лениво после opt-in из CMP-баннера
 */
export default defineNuxtPlugin({
  name: 'analyticsRoot:plugin',
  dependsOn: ['alt-container:plugin'],
  parallel: true,
  async setup() {
    const { support, store } = useAnalytics()
    const { restore, analyticsAllowed } = useConsent()

    await support.loadConfig().catch(() => undefined)
    restore()

    support.initMetrikaIfAllowed(analyticsAllowed())

    // Lazy-init после согласия из баннера
    watch(
      () => store.consent,
      () => support.initMetrikaIfAllowed(analyticsAllowed()),
    )
  },
})
